/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.19.1-30-g35acb1d6-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const SSHTargetAuthSshTargetPasswordAuthKindEnum = {
    Password: 'Password'
};
/**
 * Check if a given object implements the SSHTargetAuthSshTargetPasswordAuth interface.
 */
export function instanceOfSSHTargetAuthSshTargetPasswordAuth(value) {
    if (!('password' in value) || value['password'] === undefined)
        return false;
    if (!('kind' in value) || value['kind'] === undefined)
        return false;
    return true;
}
export function SSHTargetAuthSshTargetPasswordAuthFromJSON(json) {
    return SSHTargetAuthSshTargetPasswordAuthFromJSONTyped(json, false);
}
export function SSHTargetAuthSshTargetPasswordAuthFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'password': json['password'],
        'kind': json['kind'],
    };
}
export function SSHTargetAuthSshTargetPasswordAuthToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'password': value['password'],
        'kind': value['kind'],
    };
}
